import React from "react"
import { graphql, useStaticQuery } from "gatsby"
import ArrowRight from "../../../icons/phosphor/regular/ArrowRight"
import { CaseStudiesHeroWrapper } from "./CaseStudiesHero.styles"
import {
  prefixStatamicAssetUrl,
  statamicAssetToFixed,
} from "../../../utils/statamicAssets"

/**
 * @returns {{
 *   title: string,
 *   subHeading: string | null,
 *   intro: string | null,
 *   image: {
 *     title: string,
 *     fixed: {
 *       width: number,
 *       height: number,
 *       src: string
 *     }
 *   } | null,
 *   buttonText: string | null,
 *   buttonFileUrl: string | null,
 *   buttonLink: string | null
 * } | null}
 */
function useCaseStudy(){
  const query = useStaticQuery(graphql`
    query CaseStudiesPageHero {
      statamic {
        globalSet(handle: "case_studies_page") {
          ... on Statamic_GlobalSet_CaseStudiesPage {
            title
            sub_heading
            intro
            button_text
            button_link
            image {
              url
              permalink
              ... on Statamic_Asset_Assets {
                alt
                width
                height
              }
            }
            button_file {
              url
              permalink
            }
          }
        }
      }
    }
  `)

  const node = query?.statamic?.globalSet
  if(!node) return null

  const buttonFile = node.button_file
  const buttonFileUrl = buttonFile
    ? prefixStatamicAssetUrl(buttonFile.permalink || buttonFile.url)
    : null

  return {
    title: node.title,
    subHeading: node.sub_heading || null,
    intro: node.intro || null,
    image: statamicAssetToFixed(node.image, { w: 540 }, {}),
    buttonText: node.button_text || null,
    buttonFileUrl,
    buttonLink: node.button_link || null,
  }
}

export default function(){
  const caseStudy = useCaseStudy()
  if(!caseStudy) return null

  const linkFromCMS = caseStudy.buttonLink?.trim()
  const href = linkFromCMS || caseStudy.buttonFileUrl
  const isExternal = href && /^https?:\/\//i.test(href)
  const extraProps = isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {}

  return (
      <CaseStudiesHeroWrapper className="px-3">
        <div className="container">

          <div className="hero-text">
            <div className="tag">Case Studies</div>
            <h1>{caseStudy.title}</h1>
          </div>

          <div className="sub-hero">
            {caseStudy.subHeading && <h2>{caseStudy.subHeading}</h2>}
            {caseStudy.image &&
              <img src={caseStudy.image.fixed.src} alt={caseStudy.image.title} width={caseStudy.image.fixed.width}
                   height={caseStudy.image.fixed.height} />}
            <div className="box">
              {caseStudy.intro && <p>{caseStudy.intro}</p>}
              {caseStudy.buttonText && href && <a href={href} className="btn" {...extraProps}>
                {caseStudy.buttonText}
                <ArrowRight />
              </a>}

            </div>
          </div>

        </div>
      </CaseStudiesHeroWrapper>
  );
};
